import { Alert } from "react-bootstrap";

export default function ErrorMessage(props: any) {
    return (
        <Alert variant={'danger'}>
            {props.children}
        </Alert>

    );
};